export default __webpack_public_path__ + "static/media/skills-icon.51d55b84.svg";